import { render, staticRenderFns } from "./rightAlert.vue?vue&type=template&id=4800a396&scoped=true&"
import script from "./rightAlert.vue?vue&type=script&lang=js&"
export * from "./rightAlert.vue?vue&type=script&lang=js&"
import style0 from "./rightAlert.vue?vue&type=style&index=0&id=4800a396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800a396",
  null
  
)

export default component.exports